var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-location-7015294") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-972, -7)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(972, 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,14 C6.16270383,13.4032706 11,9.05882353 11,5.12605882 C11,2.30567647 8.54843763,0 5.5,0 C2.45156237,0 0,2.30567647 0,5.12605882 C0,9.05882353 4.83729617,13.4031471 5.5,14 Z M2.91567596,5.229 C2.91567596,3.89076471 4.08662945,2.82038235 5.5,2.82038235 C6.9358583,2.82038235 8.08432404,3.91172353 8.08432404,5.229 C8.08432404,6.56723529 6.91337055,7.63761809 5.5,7.63761809 C4.0641417,7.63842182 2.91567596,6.54707941 2.91567596,5.229 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconBlue);
export default __webpack_public_path__ + "static/media/location-icon--blue.5b6912ac7302c28f8942afeeee30a4a9.svg";
export { ForwardRef as ReactComponent };